import { ButtonList } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export type AddContactAttributesActionProps = {
  /** The user that will be used as target user */
  user: User;
  /** Toggle the parent dropdown between open and closed */
  toggleDropdown: () => void;
};

/**
 * Add contact attribute action
 *
 * A dropdown menu item that opens the add contact attributes modal.
 */
export const AddContactAttributesAction = ({
  user,
  toggleDropdown,
}: AddContactAttributesActionProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'contact:addContactAttributes',
          arg: { user },
        },
      }),
    );
    toggleDropdown();
  };

  return (
    <ButtonList.Item icon="input" onClick={handleClick}>
      Edit contact attributes
    </ButtonList.Item>
  );
};
